export const COLOR_BLACK = '#000'
export const COLOR_WHITE = '#fff'

export function getColorForProgram (program) {
  if (program.classList.contains('program--mb')) {
    return '#F5968C'
  } else if (program.classList.contains('program--cs')) {
    return '#0042BF'
  } else if (program.classList.contains('program--cn')) {
    return '#E64137'
  } else {
    return '#0042BF'
  }
}
